export const reportConstants = {
  REPORT_CREATE_PERMISSION: "REPORT_CREATE_PERMISSION_CHECK",
};



// WEBPACK FOOTER //
// ./src/_constants/report.constants.js